import React from "react";
import { View } from "react-native";
import { faSearch } from "../../assets/consts/faCharCodes";
import { translate } from "../locales/translate";
import InputBase from "../nativeBase-ui/InputBase";
const InputSearch = (props: any) => {
  return (
    <View style={{ paddingHorizontal: 5, ...props.searchContainer }}>
      <InputBase
        inputStyle={{ height: 40, fontSize: 12 }}
        placeholder={translate("app.search")}
        icon={faSearch}
        {...props}
      />
    </View>
  );
};

export default InputSearch;
